module.exports = __webpack_public_path__ + "static/media/papaya-cake.10510c27.jpg";